{
  "navigation": {
    "current": "Aktuell",
    "schedule": "Zeitplan",
    "tenants": "Mieter",
    "opsCenter": "Einsatzzentrale",
    "hangars": "Hangars",
    "ramps": "Vorfelder",
    "aircraft": "Flugzeug",
    "tripSchedule": "Flugplan",
    "ops": "Ops",
    "feeCalculator": "Gebührenrechner",
    "hangarOptimization": "Hangar-Optimierungsrechner",
    "help": "Hilfe",
    "superAdmin": "Super-Admin",
    "settings": "Einstellung",
    "logout": "Abmelden",
    "logoAlt": "AirPLX-Logo"
  },
  "timeControl": {
    "prevTrip": "Vorh. Flug",
    "nextTrip": "Nächster Flug",
    "now": "Jetzt",
    "today": "Heute",
    "daily": "Täglich",
    "15m": "15m",
    "previousDay": "Vorheriger Tag",
    "nextDay": "Nächster Tag",
    "viewSchedule": "Zeitplan anzeigen",
    "timeSelectionAriaLabel": "Zeitschieberegler",
    "tripDurationTitle": "Ausgewählte Flugzeug-Flugdauer",
    "noPreviousTrips": "Keine früheren Flüge",
    "noPreviousTripsForAircraft": "Keine früheren Flüge für {{tailNumber}}",
    "jumpToPreviousTrip": "Zum vorherigen Flug springen",
    "jumpToPreviousTripForAircraft": "Zum vorherigen Flug für {{tailNumber}} springen",
    "noFutureTrips": "Keine geplanten Flüge",
    "noFutureTripsForAircraft": "Keine zukünftigen Flüge für {{tailNumber}}",
    "jumpToNextTrip": "Zum nächsten Flug springen",
    "jumpToNextTripForAircraft": "Zum nächsten Flug für {{tailNumber}} springen"
  },
  "tripListDisplay": {
    "noTripsFound": "Keine Flüge gefunden",
    "noOwner": "Kein Inhaber"
  },
  "bulkApplyFloatingAction": {
    "applyButton": "Anwenden",
    "message": "Massenaktion anwenden"
  },
  "dimensionInput": {
    "currentPrefix": "Aktuell:",
    "errorMessage": "Ungültige Dimension",
    "unit": "ft"
  },
  "equipmentTable": {
    "nameHeader": "Name",
    "lengthHeader": "Länge",
    "widthHeader": "Breite",
    "heightHeader": "Höhe",
    "towBarHeader": "Schleppst.",
    "actionsHeader": "Aktionen",
    "editButton": "Ändern",
    "deleteButton": "Löschen"
  },
  "obstaclePreview": {
    "title": "Hindernis-Vorschau",
    "emptyState": "Wähle ein Hindernis zur Vorschau aus",
    "noImageAvailable": "Kein Bild verfügbar",
    "dimensionsLabel": "Abmessungen",
    "lengthLabel": "Länge",
    "widthLabel": "Breite",
    "heightLabel": "Höhe",
    "unit": "ft"
  },
  "obstacleTable": {
    "nameHeader": "Name",
    "lengthHeader": "Länge",
    "widthHeader": "Breite",
    "heightHeader": "Höhe",
    "actionsHeader": "Aktionen",
    "editButton": "Bearb.",
    "deleteButton": "Löschen"
  },
  "recentPatternsPanel": {
    "title": "Letzte Muster",
    "lastPrefix": "Letzte:",
    "appliedSuffix": "angewendet",
    "never": "Nie",
    "reApplyButton": "Neu anwenden",
    "unknownAircraft": "Unbekanntes Flugzeug"
  },
  "vipTagSelect": {
    "label": "Tags",
    "addTag": "Hinzufügen",
    "editTags": "Tags ändern",
    "noTags": "Keine Tags"
  },
  "notFoundCard": {
    "hangarTitle": "Hangar nicht gefunden",
    "rampTitle": "Vorfeld nicht gefunden",
    "hangarMessage": "Der gesuchte Hangar existiert nicht oder Sie haben keinen Zugriff mehr.",
    "rampMessage": "Das gesuchte Vorfeld existiert nicht oder Sie haben keinen Zugriff mehr.",
    "goToHangars": "Zu Hangars",
    "goToRamps": "Zu Vorfeldern"
  },
  "activation": {
    "title": "Erste Schritte",
    "subtitle": "5 Schritte zum AirPlx-Profi",
    "steps": {
      "addAircraft": {
        "title": "Flugzeug hinzufügen",
        "description": "Fügen Sie ein Mandanten-Flugzeug zu Ihrem Hangar hinzu"
      },
      "firstAutostack": {
        "title": "AutoStack ausführen",
        "description": "Lassen Sie den Algorithmus Ihre Flugzeuge anordnen"
      },
      "secondAutostack": {
        "title": "Anderes Szenario testen",
        "description": "AutoStack mit anderen Flugzeugen erneut ausführen"
      },
      "saveFavorite": {
        "title": "Layout speichern",
        "description": "Erstellen Sie einen Favoriten zum späteren Nachschlagen"
      },
      "shareLayout": {
        "title": "Mit Ihrem Team teilen",
        "description": "Layout drucken, Link kopieren oder per E-Mail senden"
      },
      "runAutostack": "Weiter"
    },
    "progress": "{{completed}} von {{total}} abgeschlossen",
    "dismiss": "Vorerst ausblenden",
    "completed": "Abgeschlossen",
    "complete": {
      "title": "Fertig!",
      "message": "Sie haben die Einrichtung abgeschlossen. AirPlx ist bereit.",
      "dismiss": "Verstanden"
    }
  }
}
